import { render } from "./SetHcpiBreakDialog.vue?vue&type=template&id=25a88ba8"
import script from "./SetHcpiBreakDialog.vue?vue&type=script&lang=js"
export * from "./SetHcpiBreakDialog.vue?vue&type=script&lang=js"
script.render = render

export default script